import girl1 from '../images/project/project-1/girl/g1.jpg'
import girl2 from '../images/project/project-1/girl/g2.jpg'
import girl3 from '../images/project/project-1/girl/g3.jpg'
import girl4 from '../images/project/project-1/girl/g4.jpg'
import girl5 from '../images/project/project-1/girl/g5.jpg'
import girl6 from '../images/project/project-1/girl/g6.jpg'
import girl7 from '../images/project/project-1/girl/g7.jpg'
import girl8 from '../images/project/project-1/girl/g8.jpg'
import girl9 from '../images/project/project-1/girl/g9.jpg'
import girl10 from '../images/project/project-1/girl/g10.jpg'
import girl11 from '../images/project/project-1/girl/g11.jpg'
import girl12 from '../images/project/project-1/girl/g12.jpg'
import girl13 from '../images/project/project-1/girl/g13.jpg'
import girl14 from '../images/project/project-1/girl/g14.jpg'
import girl15 from '../images/project/project-1/girl/g15.jpg'
import girl16 from '../images/project/project-1/girl/g16.jpg'
import girl17 from '../images/project/project-1/girl/g17.jpg'
import girl18 from '../images/project/project-1/girl/g18.jpg'

// women
import women1 from '../images/project/project-1/women/w1.jpg'
import women2 from '../images/project/project-1/women/w2.jpg'
import women3 from '../images/project/project-1/women/w3.jpg'
import women4 from '../images/project/project-1/women/w4.jpg'
import women5 from '../images/project/project-1/women/w5.jpg'
import women6 from '../images/project/project-1/women/w6.jpg'
import women7 from '../images/project/project-1/women/w7.jpg'
import women8 from '../images/project/project-1/women/w8.jpg'
import women9 from '../images/project/project-1/women/w9.jpg'
import women10 from '../images/project/project-1/women/w10.jpg'
import women11 from '../images/project/project-1/women/w11.jpg'
import women12 from '../images/project/project-1/women/w12.jpg'
import women13 from '../images/project/project-1/women/w13.jpg'
import women14 from '../images/project/project-1/women/w14.jpg'
import women15 from '../images/project/project-1/women/w15.jpg'
import women16 from '../images/project/project-1/women/w16.jpg'
import women17 from '../images/project/project-1/women/w17.jpg'
import women18 from '../images/project/project-1/women/w18.jpg'
import women19 from '../images/project/project-1/women/w19.jpg'
import women20 from '../images/project/project-1/women/w20.jpg'

// men
import men1 from '../images/project/project-1/men/m1.jpg'
import men2 from '../images/project/project-1/men/m2.jpg'
import men3 from '../images/project/project-1/men/m3.jpg'
import men4 from '../images/project/project-1/men/m4.jpg'
import men5 from '../images/project/project-1/men/m5.jpg'
import men6 from '../images/project/project-1/men/m6.jpg'
import men7 from '../images/project/project-1/men/m7.jpg'
import men8 from '../images/project/project-1/men/m8.jpg'
import men9 from '../images/project/project-1/men/m9.jpg'
import men10 from '../images/project/project-1/men/m10.jpg'
import men11 from '../images/project/project-1/men/m11.jpg'
import men12 from '../images/project/project-1/men/m12.jpg'
import men13 from '../images/project/project-1/men/m13.jpg'
import men14 from '../images/project/project-1/men/m14.jpg'
import men15 from '../images/project/project-1/men/m15.jpg'
import men16 from '../images/project/project-1/men/m16.jpg'
import men17 from '../images/project/project-1/men/m17.jpg'
import men18 from '../images/project/project-1/men/m18.jpg'
import men19 from '../images/project/project-1/men/m19.jpg'
import men20 from '../images/project/project-1/men/m20.jpg'

// boy
import boy1 from '../images/project/project-1/boy/b1.jpg'
import boy2 from '../images/project/project-1/boy/b2.jpg'
import boy3 from '../images/project/project-1/boy/b3.jpg'
import boy4 from '../images/project/project-1/boy/b4.jpg'
import boy5 from '../images/project/project-1/boy/b5.jpg'
import boy6 from '../images/project/project-1/boy/b6.jpg'
import boy7 from '../images/project/project-1/boy/b7.jpg'
import boy8 from '../images/project/project-1/boy/b8.jpg'
import boy9 from '../images/project/project-1/boy/b9.jpg'
import boy10 from '../images/project/project-1/boy/b10.jpg'
import boy11 from '../images/project/project-1/boy/b11.jpg'
import boy12 from '../images/project/project-1/boy/b12.jpg'
import boy13 from '../images/project/project-1/boy/b13.jpg'
import boy14 from '../images/project/project-1/boy/b14.jpg'
import boy15 from '../images/project/project-1/boy/b15.jpg'
import boy16 from '../images/project/project-1/boy/b16.jpg'
import boy17 from '../images/project/project-1/boy/b17.jpg'
import boy18 from '../images/project/project-1/boy/b18.jpg'
import boy19 from '../images/project/project-1/boy/b19.jpg'
import boy20 from '../images/project/project-1/boy/b20.jpg'


const Projects = [
  {
    id: '1',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Modern-House',
    pimg: girl1,
    // sing: Sing1,
    subTitle: 'g',
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '50',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy10,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
{
    id: '21',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women3,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
  {
    id: '58',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy18,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },


  {
    id: '2',
   title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Modern-House',
    pimg: girl2,
    subTitle: 'g',
    // sing: Sing2,
    date: 'March 2025',
    location: 'Austria',
  },

  {
    id: '35',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women15,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
  {
    id: '3',
   title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Interior-Design',
    pimg: girl3,
    subTitle: 'g',
    // sing: Sing3,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '53',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy13,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '30',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women10,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
  {
    id: '4',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Interior-Design',
    pimg: girl4,
    subTitle: 'g',
    // sing: Sing4,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '5',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Modern-House2',
    pimg: girl5,
    subTitle: 'g',
    // sing: Sing5,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '6',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Art-Museum',
    pimg: girl6,
    subTitle: 'g',
    // sing: Sing6,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '7',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Farm-House',
    pimg: girl7,
    subTitle: 'g',
    // sing: Sing7,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '8',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl8,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },

  {
    id: '9',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl9,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
  {
    id: '10',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl10,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '11',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl11,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '12',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl12,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '13',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl13,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '14',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl14,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '15',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl15,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '16',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl16,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '17',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl17,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },
{
    id: '18',
    title: 'Girl',
    subtitle: 'Girl Collection',
    slug: 'Dream-House',
    pimg: girl18,
    subTitle: 'g',
    // sing: Sing8,
    date: 'March 2025',
    location: 'Austria',
  },


// women

  {
    id: '19',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women1,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '20',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women2,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },

  
{
    id: '24',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women4,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '25',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women5,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '25',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women6,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '27',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women7,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '28',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women8,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '29',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women9,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },

{
    id: '31',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women11,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '32',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women12,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '33',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women13,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '34',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women14,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },

{
    id: '36',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women16,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '37',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women17,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '38',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women18,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '39',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women19,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },
{
    id: '40',
    title: 'Women',
    subtitle: 'Women Collection',
    slug: '',
    pimg: women20,
    subTitle: 'w',
    // sing: Sing7,
    date: '',
    location: '',
  },


// Boy
  {
    id: '41',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy1,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '42',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy2,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
{
    id: '43',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy3,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '44',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy4,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '45',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy5,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '46',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy6,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '47',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy7,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '48',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy8,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '49',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy9,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  
  {
    id: '51',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy11,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '52',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy12,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  
  {
    id: '54',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy14,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '55',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy15,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '56',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy16,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '57',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy17,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  
  {
    id: '59',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy19,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '60',
    title: 'Boy',
    subtitle: 'Boy Collection',
    slug: '',
    pimg: boy20,
    subTitle: 'b',
    // sing: Sing8,
    date: '',
    location: '',
  },

  // men
  {
    id: '61',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men1,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '62',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men2,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '63',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men3,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '64',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men4,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '65',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men5,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '66',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men6,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '67',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men7,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '68',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men8,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '69',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men9,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '70',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men10,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '71',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men11,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '72',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men12,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '73',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men13,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '74',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men14,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '75',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men15,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '76',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men16,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '77',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men17,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '78',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men18,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '79',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men19,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
  {
    id: '80',
    title: 'Men',
    subtitle: 'Men Collection',
    slug: '',
    pimg: men20,
    subTitle: 'm',
    // sing: Sing8,
    date: '',
    location: '',
  },
]
export default Projects
